import { Control } from 'ol/control';

const controlApp = {};

const createControlButton = (buttonClass, elementClass, handler) => {
  const button = document.createElement('button');
  button.className = buttonClass;

  button.addEventListener('click', handler);
  const element = document.createElement('div');
  element.className = `${elementClass} ol-unselectable ol-control`;
  element.appendChild(button);

  return element;
};

controlApp.centerToUserLocation = (map) => {
  const handler = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      map.getView().setCenter([position.coords.longitude, position.coords.latitude]);
    });
  };

  const element = createControlButton('icon-kp-gps', 'center-user-location', handler);

  return new Control({ element });
};

export default controlApp;



// WEBPACK FOOTER //
// ./src/services/map/control.js